import { TSlugRecord } from '@bridebook/web/components/quiz/at-your-venue-quiz/at-your-venue-quiz-steps/texts';
import { TOmittedSlugRecord } from '@bridebook/web/components/quiz/at-your-venue-quiz/types';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

export const CATEGORIES_OPTIONS: TOmittedSlugRecord[] = [
  'photo',
  'florist',
  'catering',
  'music',
  'video',
  'decoration',
  'entertainment',
  'cakes',
  'beauty',
  'dress',
  'dress',
  'transport',
  'menswear',
  'stationery',
  'marquee',
];

export const categoriesImages: Omit<TSlugRecord, 'group' | 'jewellery' | 'planners' | 'venue'> = {
  photo: `${IMAGES_BASE_URL}/assets/at-your-venue/photographer.jpg`,
  florist: `${IMAGES_BASE_URL}/assets/at-your-venue/florist.jpg`,
  catering: `${IMAGES_BASE_URL}/assets/at-your-venue/caterer.jpg`,
  music: `${IMAGES_BASE_URL}/assets/at-your-venue/music.jpg`,
  video: `${IMAGES_BASE_URL}/assets/at-your-venue/videographer.jpg`,
  decoration: `${IMAGES_BASE_URL}/assets/at-your-venue/decorator.jpg`,
  entertainment: `${IMAGES_BASE_URL}/assets/at-your-venue/entertainment.png`,
  cakes: `${IMAGES_BASE_URL}/assets/at-your-venue/cake.jpg`,
  beauty: `${IMAGES_BASE_URL}/assets/at-your-venue/beauty.jpg`,
  dress: `${IMAGES_BASE_URL}/assets/at-your-venue/dress.jpg`,
  transport: `${IMAGES_BASE_URL}/assets/at-your-venue/transport.jpg`,
  menswear: `${IMAGES_BASE_URL}/assets/at-your-venue/menswear.jpg`,
  stationery: `${IMAGES_BASE_URL}/assets/at-your-venue/stationery.jpg`,
  marquee: `${IMAGES_BASE_URL}/assets/at-your-venue/marquee.jpg`,
};
